<template>
  <md-dialog
    :id="refName"
    :ref="refName"
    :md-title="title"
  >
    <md-dialog-title class="px-6">
      <div
        class="mb-6"
      >
        <h2 class="title-main">
          {{ title }}
        </h2>
      </div>
      <button
        v-if="closeButtonEnabled"
        class="close-button btn-transparent"
        @click="close()"
      >
        <md-icon>clear</md-icon>
      </button>
    </md-dialog-title>

    <md-dialog-content class="px-6">
      <slot />
    </md-dialog-content>

    <md-dialog-actions class="px-6">
      <slot name="actions">
        <md-button
          v-if="firstButtonSubText"
          @click="firstButtonAction"
        >
          {{ firstButtonSubText }}
        </md-button>
        <md-button
          v-if="secondButtonSubText"
          class="btn-fetch"
          @click="secondButtonAction"
        >
          {{ secondButtonSubText }}
        </md-button>
      </slot>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import mixin from '../modalMixin'

export default {
  name: 'ModalFilter',
  mixins: [mixin],
  props: {
    firstButtonSubText: {
      type: String,
      default: null
    },
    secondButtonSubText: {
      type: String,
      default: 'Buscar'
    }
  },
  data: () => ({
    showDialog: false
  })
}
</script>

<style scoped lang="scss">
  :deep(.md-dialog) {
    max-width: 800px;
    width: 100%;
    overflow: visible !important;
    .md-dialog-content {
      overflow: visible !important;
    }
  }

  .btn-fetch{
    color: #7f1a54;
  }
</style>
